import { AppState } from "../../../redux-configuration/AppState";

export const postInstantOnFacebookLoadingSelector = (appState: AppState): boolean=> appState.managementInstant.postInstantOnFacebook.loading
export const postInstantOnFacebookErrorSelector = (appState: AppState): string | undefined => appState.managementInstant.postInstantOnFacebook.error
